import React from "react";

function NoDealerAccountScreen(message) {
    return (<p>{message}</p>);
}

export default NoDealerAccountScreen;